import React,{useState} from 'react';
import {Box, Stack} from '@mui/material';
import TopBar from "../../../../../../../../component/TopBar";
import MainBox from "../../../../../../container/MainBox";
import ActiveBar from "../../../../../../../../component/PolicyNavbarUpdated";
import BtnSecondary from '../../../../../../../../component/SecondaryButton';
import SortBy from './SortBy';
import CreateGroup from '../../../../../../../../component/CreateGroup';

const AssignPolicy = () => {

  const [page, setPage] = useState("sortBy");

  const loadNextPage = (p) => {
    setPage(p);
  };

  const commonProps = {
    loadNextPage,
  };

  const sortByProps = {
    ...commonProps,
  };

  const createGroupProps = {
    ...commonProps,
    redirectLink: "/app/expense-policy/new/assign-policy", 
  };


  const mapPages = {
    sortBy: (props) => <SortBy {...sortByProps} />,
    createGroup: (props) => <CreateGroup {...createGroupProps} />,
  };

  const ShowPage = mapPages[page];
 
  return (
      <Box sx={{width:"100%"}}>
          <TopBar MainHeading={"Expense Policy"} breadcrumbs={[{label:"Expense Policy", href:"/app/expense-policy/listing"},{label:"Assign"}]}/>
          <MainBox sx={{ padding: "2rem 1.25rem" }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.5rem" }}>
                <ActiveBar active={["Policy Details","Add Category","Assign Policy"]}/>
                <BtnSecondary
                  sx={{ height: "2.5rem", px: "1.25rem", borderRadius: "10px" }}
                  onClick={()=>{page==="sortBy"?loadNextPage("createGroup"):loadNextPage("sortBy")}}
                >
                    {page==="sortBy"?"+ Create Group":"Back"}
                </BtnSecondary>
            </Stack>
            <ShowPage/>
          </MainBox>
      </Box>
    )
}

export default AssignPolicy;